export const formatDate = {
    thai,
  };
  function thai(dateFormat){
    const createdDate = new Date(dateFormat)
    const monthNamesThai = ["ม.ค.", "ก.พ.", "ม.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
    const createDateFormat = `${createdDate.getDate()} ${monthNamesThai[createdDate.getMonth()]} ${createdDate.getFullYear().toString().substr(-2)}`
    return createDateFormat
  }